import React from 'react';

import { ErrorBoundarySuspense } from 'src/components/suspenses/ErrorBoundarySuspense';
import { ConfigurationCriteria } from 'src/features/configuration/configurationCriteria/ConfigurationCriteria';
import { ConfigurationCriteriaSkeleton } from 'src/features/configuration/configurationCriteria/ConfigurationCriteriaSkeleton';
import { useForecastSession } from 'src/features/forecastSessions/useForecastSession';
import { QUERY_KEY_OPEN_SESSION_CRITERIA } from 'src/keys';

export function ConfigurationCriteriaContainer() {
  const { activeSession } = useForecastSession();

  if (!activeSession?.id) {
    return <ConfigurationCriteriaSkeleton />;
  }

  return (
    <ErrorBoundarySuspense
      errorFallbackWrapper={
        <div className={'flex h-44 w-full flex-col gap-y-4 p-4'} />
      }
      queryKey={[QUERY_KEY_OPEN_SESSION_CRITERIA, activeSession?.id]}
      loadingFallback={<ConfigurationCriteriaSkeleton />}
    >
      <ConfigurationCriteria sessionId={activeSession.id} />
    </ErrorBoundarySuspense>
  );
}
